<template>
  <div class="more-away">
    <div class="ha-des">
      <p class="black">手机号登录的话，手机不在身边怎么办？</p>
      <p>在可瀚学堂App 1.5版本，新增了密码登录功能，首次在1.5版本登陆时，即会提醒您设置密码。以后就可以使用密码登录。如果您的手机没有密码登录入口，请更新可瀚学堂App至v1.5</p>
    </div>
    <div class="ha-img">
      <img src="./img/away.png" alt="">
    </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .more-away {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
      a {
        color: $blue;
      }
    }
    .ha-img {
      width: 100%;
      padding-right: p2r(30);
      img {
        width: 100%;
      }
    }
  }
</style>
<script>
  export default{
    data(){
      return {}
    },
    created(){
      document.title = '其他问题? 可瀚学堂-深圳市格熙信息科技有限公司'
      this.$sendAnalytics('点击手机号登录的话，手机不在身边怎么办')
    },
    methods: {
      skip(name) {
        this.$router.push({
          name: name
        });
      }
    },
    components: {}
  }
</script>
